import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Icon } from './../../component/icon';
import { imageResizeBaseUrl, getProp } from './../../utilities.js';
import './photogallery.css';
let Lightbox;
if (typeof window !== 'undefined') {
  Lightbox = require('react-image-lightbox').default;
}

class Photogallery extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lightboxIsOpen: false,
      lightboxCurrentIdx: 0,
      galleryOffset: 0,
      galleryLimit: 3,
    };
  }

  openLightbox(idx) {
    this.setState({
      lightboxIsOpen: true,
      lightboxCurrentIdx: idx,
    });
  }

  closeLightbox() {
    this.setState({
      lightboxIsOpen: false,
      lightboxCurrentIdx: 0,
    });
  }

  gotoPrevLightboxImage() {
    this.setState({
      lightboxCurrentIdx: this.state.lightboxCurrentIdx - 1,
    });
  }

  gotoNextLightboxImage() {
    this.setState({
      lightboxCurrentIdx: this.state.lightboxCurrentIdx + 1,
    });
  }

  onClickNext() {
    if (this.isNextAvailable()) {
      this.setState({
        galleryOffset: this.state.galleryOffset + 1,
      });
    }
  }

  onClickPrev() {
    if (this.isPrevAvailable()) {
      this.setState({
        galleryOffset: this.state.galleryOffset - 1,
      });
    }
  }

  isNextAvailable() {
    return !(
      this.state.galleryOffset + this.state.galleryLimit >
      this.props.photos.length - 1
    );
  }

  isPrevAvailable() {
    return !(this.state.galleryOffset <= 0);
  }

  render() {
    let nextImg, nextSrc, prevImg, prevSrc;
    nextImg = this.props.photos[this.state.lightboxCurrentIdx + 1];
    if (nextImg) {
      nextSrc = `${imageResizeBaseUrl(1000, 0, this.props.imageBaseUrl)}/${
        nextImg.uri
        }`;
    }
    prevImg = this.props.photos[this.state.lightboxCurrentIdx - 1];
    if (prevImg) {
      prevSrc = `${imageResizeBaseUrl(1000, 0, this.props.imageBaseUrl)}/${
        prevImg.uri
        }`;
    }

    const images = getProp(this.props, 'photos', []).reduce((p, next) => {
      return [
        ...p,
        `${imageResizeBaseUrl(1000, 0, this.props.imageBaseUrl)}/${
        next.uri
        }?v=1`,
      ];
    }, []);
    if (typeof window !== 'undefined') {
      return (
        <div className="photogallery">
          {this.props.photos.length > this.state.galleryLimit && (
            <span
              className={cx('control control-prev', {
                disabled: !this.isPrevAvailable(),
              })}
              onClick={this.onClickPrev.bind(this)}
            >
              <Icon name="chevron-circle-right" />
            </span>
          )}
          <div className="row strip">
            {this.props.photos
              .slice(
                this.state.galleryOffset,
                this.state.galleryOffset + this.state.galleryLimit,
              )
              .map((item, idx) => {
                return (
                  <div key={idx} className="col-xs-12 col-sm-4">
                    <span className="thumbnail">
                      <a
                        href=""
                        onClick={(e) => {e.preventDefault(); this.openLightbox(idx)}}
                        title={getProp(item, 'name', undefined)}
                        style={{
                          backgroundImage: `url(${imageResizeBaseUrl(
                            500,
                            0,
                            this.props.imageBaseUrl,
                          )}/${item.uri}?v=1)`,
                        }}
                      >{null}</a>
                    </span>
                  </div>
                );
              })}
            {this.state.lightboxIsOpen && (
              <Lightbox
                mainSrc={images[this.state.lightboxCurrentIdx]}
                nextSrc={nextSrc}
                prevSrc={prevSrc}
                onCloseRequest={this.closeLightbox.bind(this)}
                onMovePrevRequest={this.gotoPrevLightboxImage.bind(this)}
                onMoveNextRequest={this.gotoNextLightboxImage.bind(this)}
              />
            )}
          </div>
          {this.props.photos.length > this.state.galleryLimit && (
            <span
              className={cx('control control-next', {
                disabled: !this.isNextAvailable(),
              })}
              onClick={this.onClickNext.bind(this)}
            >
              <Icon name="chevron-circle-right" />
            </span>
          )}
        </div>
      );
    }
    return null;
  }
}

Photogallery.propTypes = {
  photos: PropTypes.array.isRequired,
  imageBaseUrl: PropTypes.string,
};

export default Photogallery;



// WEBPACK FOOTER //
// ./src/ui/src/component/photogallery/photogallery.js